// window.dashboardData is set by wp_localize_script in inc/scripts-styles.php
const { nonce, apiUrl, userId, displayName } = window.dashboardData ?? {};

export default function App() {
  return (
    <div className="dashboard-react-root">
      <p>Hello, toots.</p>
    </div>
  );
}
